import { render, staticRenderFns } from "./AddInvoice.vue?vue&type=template&id=0c23e06e&scoped=true&"
import script from "./AddInvoice.vue?vue&type=script&lang=js&"
export * from "./AddInvoice.vue?vue&type=script&lang=js&"
import style0 from "./AddInvoice.vue?vue&type=style&index=0&id=0c23e06e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c23e06e",
  null
  
)

export default component.exports